/**
 * API functions to get cooker data using promises
 * Uses fetch() to grab the data (which may be stored with ServiceWorkers)
 * and prep-pull image data
 * This is the default API and used for Android/web
 */

import { CookerDatabase } from './base';

export class FetchCookerDatabase extends CookerDatabase {

    /**
     * Search database for cookers matching the spec.
     * TODO: Make sure to clear blob URLs if needed.
     * @return {Promise<Object[]>}
     */
    async query(search) {
        let cookerData = await fetch('api/v1/cookers', { credentials: 'include' }).then(r => r.json());

        return cookerData.cookers.filter(cooker => (
            (!search.size || cooker.attributes.size == search.size)
            && (!search.fuel || cooker.attributes.fuel == search.fuel)
            && (
                (!search.style) ||
                (search.style == 'traditional' && cooker.attributes.isTraditional) ||
                (search.style == 'modern' && cooker.attributes.isContemporary)
            )
            && (!search.function || cooker.attributes.isMultifunctionalOven == (search.function == 'multifunction'))
        ))
    }

    async getCookerHoodsFor(cookerId){
        let cookerData = await fetch('api/v1/cookers', { credentials: 'include' }).then(r => r.json());
        let hoodData = await fetch('/api/v1/cookerhoods', { credentials: 'include' }).then( r=> r.json());
        return hoodData.data.filter( hood => hood.cookers.includes(parseInt(cookerId)) ).map( hood => Object.assign(hood, {
            colours: hood.colours.map( col => ({ lbl: col, colorCode: cookerData.colours[col]  }) )
        }))
    }

    /**
     * Search w/o attachements, get the count
     * @param {*} search 
     */
    async getFuelOptions(search) {
        return (await this.query(search)).reduce((res, cooker) => {
            if (res.indexOf(cooker.fuel) === -1) {
                res.push(cooker.fuel);
            }
            return res;
        }, [])
    }

    async get(id) {
        let cookerData = await fetch('api/v1/cookers', { credentials: 'include' }).then(r => r.json());
        let cooker = cookerData.cookers.find(cooker => cooker.id == id)
        if (cooker) {
            cooker.variations = cooker.variations.map(variation => {
                //TODO: Name hacks fix in DB
                variation.color = variation.color == 'SS' ? 'Stainless Steel' : variation.color;
                variation.colorCode = cookerData.colours[variation.color];
                //TODO: Name hacks fix in DB
                variation.colorCode = variation.color == 'Gloss Black' ? '000000' : variation.colorCode;
                return variation;
            })
            return cooker;
        }
        throw new Error('No cooker with that id found');
    }

    /**
     * @callback UpdateCallback
     * @param {number} current
     * @param {number} total
     * @param {string} currentItemName
     */

    /**
     * @param {UpdateCallback} progressCallback
     * Prep database for offline access
     */
    async update(progressCallback = () => { }) {
        // progressCallback(0, 1, 'Fetching latest cooker list');
        return _update(progressCallback);
        //TODO: message service worker

    }

    /**
     * Get the release date of the last update
     */
    async lastUpdate() {
        return (await fetch('api/v1/cookers').then(r => r.json())).last_updated
    }

    /**
     * Check if an update is available
     */
    updateAvailable() {
        throw new Error('not implemented');
    }

    async isFirstRun() {
        try {
            let d = await caches.match('api/v1/cookers');
            return !d;
        } catch (e) {
            return false;
        }
    }

    getName() {
        return 'FetchDB';
    }
}

let _activeServiceWorker = null

export function setServiceWorker(sw) {
    _activeServiceWorker = sw;
}

export function _update(cb) {
    if (_activeServiceWorker == null) {
        return Promise.reject(new Error('No service worker installed.'));
    }
    let chan = new MessageChannel()
    return new Promise((resolve, reject) => {
        chan.port1.onmessage = ({ data }) => {
            cb(data.done, data.todo, data.items)
            if (data.done / data.todo == 1) {
                resolve();
            }
            if (data.error) {
                console.error('Error during update');
                reject(data.error);
            }
        }
        _activeServiceWorker.postMessage('UPDATE_PROCESS', [chan.port2]);
    })
}


// WEBPACK FOOTER //
// ./src/api/backend/fetch.js